// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display:block}.filter-directory{display:flex;flex-direction:column;gap:var(--uap-builder-items-padding-left-right)}.filter-directory-integration{display:flex;align-items:center;gap:10px}.filter-directory uo-accordion-item-li strong{font-weight:500;color:var(--uap-color-blue)}.uap-hidden{display:none}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
